import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { action } from 'mobx'
import { observer } from 'mobx-react'
import { withStyles } from 'material-ui/styles'
import withAppStore from 'decorators/withAppStore'
import inject from 'helpers/inject'

import Card, { CardContent, CardActions } from 'material-ui/Card'
import Button from 'material-ui/Button'
import Divider from 'material-ui/Divider'
import List, { ListItem, ListItemIcon, ListItemText } from 'material-ui/List'
import Typography from 'material-ui/Typography'
import CardTitle from 'components/CardTitle'
import { Database, Speedometer, CreditCard, CreditCardMultiple } from 'mdi-material-ui'

import RouterService from 'services/router'

import getApiKeys from 'tasks/getApiKeys'

import styles from 'styles/components/ServiceCard'

@withStyles(styles)
@withAppStore
@observer
export default class ServiceCard extends Component {

  static propTypes = {
    service: PropTypes.shape({
      name: PropTypes.string.isRequired,
      api: PropTypes.bool,
      throttling: PropTypes.number.isRequired,
      price_per_month: PropTypes.number.isRequired,
      price_per_year: PropTypes.number.isRequired
    }).isRequired
  }

  router = inject(RouterService)

  render() {
    const { service, classes } = this.props

    return (
      <Card elevation={1} className={ classes.card } >

        <CardTitle title={ service.name } />

        <div className={ classes.wrapper } >
          <CardContent className={ classes.content } >
            <List >

              <ListItem className={ classes.listItem } >
                <ListItemIcon>
                  <Database />
                </ListItemIcon>
                <ListItemText
                  primary='Доступ к данным:'
                />
                <ListItemText align='right' className={ classes.nopadding }
                  primary={ service.api ? 'Есть' : 'Нет' }
                />
              </ListItem>

              <ListItem className={ classes.listItem } >
                <ListItemIcon>
                  <Speedometer />
                </ListItemIcon>
                <ListItemText
                  primary='Количество запросов:'
                />
                <ListItemText align='right' className={ classes.nopadding }
                  primary={ `${service.throttling} в день` }
                />
              </ListItem>

              <ListItem className={ classes.listItem } >
                <ListItemIcon>
                  <CreditCard />
                </ListItemIcon>
                <ListItemText
                  primary='Цена при оплате за месяц:'
                />
                <ListItemText align='right' className={ classes.nopadding }
                  primary={ `${service.price_per_month} руб.` }
                />
              </ListItem>

              <ListItem className={ classes.listItem } >
                <ListItemIcon>
                  <CreditCardMultiple />
                </ListItemIcon>
                <ListItemText
                  primary='Цена при оплате за год:'
                />
                <ListItemText align='right' className={ classes.nopadding }
                  primary={ `${service.price_per_year} руб.` }
                />
              </ListItem>

              <Divider className={ classes.divider } />

              <ListItem >
                <ListItemText
                  primary={ `Всего ключей: ${getApiKeys.result.filter(key => key.service_type === service.id).length}` }
                />
                <ListItemText disableTypography className={ classes.nopadding }
                  primary={ <Typography type='subheading' align='right' color='error' >Проблемы: 0</Typography> }
                />
              </ListItem>

            </List>
          </CardContent>
          <CardActions className={ classes.actions } >

            <Button color='primary' onClick={ this.handleKeysClick } >
              Мои ключи
            </Button>

            <Button color='primary' onClick={ this.handleBuyClick } >
              Купить ключ
            </Button>

          </CardActions>
        </div>
      </Card>
    )
  }

  @action.bound
  handleBuyClick() {
    this.appStore.showCreateKeyModal(this.props.service)
  }

  @action.bound
  handleKeysClick() {
    this.router.transitionTo(`/keys?service=${this.props.service.id}`)
  }

}



// WEBPACK FOOTER //
// ./src/components/ServiceCard.js